import React, { useState, useCallback } from "react";
import { ButtonGroup, Button } from "@shopify/polaris";

import { ExportTemplateRemoveActionPolaris } from "./ExportTemplateRemoveActionPolaris";
import { ExportTemplateCloneActionPolaris } from "./ExportTemplateCloneActionPolaris";
import {  ExportTemplateUpdateDefault } from "./export-template-update-default-action";

export const ExportTemplateActionsPolaris = ({
  item,
  refetch,
  hasActionsRemove,
  toggleActive,
  onNotificationChange,
}) => {
  // State
  const [showModal, setShowModal] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);

  const toggleShowModal = useCallback((action) => {
    setShowModal((prev) => !prev);
    setCurrentAction(action);
  }, []);

  return (
    <div style={{ display: 'flex', gap: 10}}>
      {hasActionsRemove ? (
        <Button size="slim" children={"Delete"} onClick={() => toggleShowModal("remove")} />
      ) : (
        <Button size="slim" children={"Clone"} onClick={() => toggleShowModal("clone")} />
      )}

      <Button size="slim" children={"Set default"} onClick={() => toggleShowModal("setDefault")} />

      <ExportTemplateRemoveActionPolaris
        open={showModal && "remove" === currentAction}
        toggleShowModal={toggleShowModal}
        refetch={refetch}
        item={item}
        onNotificationChange={onNotificationChange}
        toggleActive={toggleActive}
      />
      <ExportTemplateCloneActionPolaris
        open={showModal && "clone" === currentAction}
        toggleShowModal={toggleShowModal}
        refetch={refetch}
        item={item}
        onNotificationChange={onNotificationChange}
        toggleActive={toggleActive}
      />
      <ExportTemplateUpdateDefault
        open={showModal && "setDefault" === currentAction}
        toggleShowModal={toggleShowModal}
        refetch={refetch}
        item={item}
        onNotificationChange={onNotificationChange}
        toggleActive={toggleActive}
      />
    </div>
  );
};
